import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from 'api/src/common/trpc/router';

export const trpc = createTRPCReact<AppRouter>();
